(function () {
    'use strict';
    $(document).ready(function () {
        console.log('main.js');

        //Smmoth scroll to

        $('.scroll-animation').on('click', function (e) {
            e.preventDefault();

            var href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        // Lang picker
        $('.lang-picker button').click(function () {
           $('.lang-picker button svg').toggleClass('open');
           $('.lang-picker .lang-list').slideToggle({
               start: function () {
                   $(this).css({
                       display: "flex"
                   })
               }
           });
        });

        //Search trigger

        $('.search-trigger').click(function () {
            $(this).toggleClass('active');
            $('.search-panel').fadeToggle('active');
            $('.search-panel .search-input').focus();
            return false;
        });

        //Menu mobile toggle

        $(".menu-toggle").click(function(){
            $(this).toggleClass("open");
            $('#site-menu').slideToggle({
                start: function () {
                    $(this).css({
                        display: "flex"
                    })
                }
            });
        });

        //Linki posiadające podmenu - wyłączenie domyślnego zachowania

        $("#site-menu > li.menu-item-has-children > a").click(function (e) {
            e.preventDefault();
        });

        $("#site-menu li.menu-item-has-children > ul," +
            "#site-menu li.menu-item-has-children > ul > li").click(function (e) {
            e.stopPropagation();
        });

        //Mainmenu - level 0

        $("#site-menu > li.menu-item-has-children").click(function () {
            var $wnd = window.innerWidth;

            if (window.matchMedia("(min-width: 1024px)").matches) {

                $(this).children('ul').fadeToggle({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });

                if ($(this).hasClass('open')) {
                    $(this).removeClass('open');
                } else {
                    $(this).addClass('open');
                }

                $(this).siblings('li').removeClass('open');
                $(this).siblings('li').children('ul').fadeOut();

            } else {

                $(this).children('ul').slideToggle({
                    start: function () {
                        $(this).css({
                            display: "flex"
                        })
                    }
                });
                $(this).siblings('li').children('ul').slideUp();

            }
        });

        $('.print-trigger').on('click', function(){
            window.print();
        })

        //Mainmenu - level 1

            // $("#site-menu > li.menu-item-has-children > ul > li.menu-item-has-children").click(function () {
            //     if (window.matchMedia("(max-width: 1023px)").matches) {
            //         $(this).children('ul').slideToggle({
            //             start: function () {
            //                 $(this).css({
            //                     display: "flex"
            //                 })
            //             }
            //         });
            //         $(this).toggleClass('open');
            //
            //         $(this).siblings('li').children('ul').slideUp();
            //         $(this).siblings('li').removeClass('open');
            //     }
            // });


        //Mainmenu - level 2

        // $("#site-menu > li.menu-item-has-children > ul > li.menu-item-has-children > ul > li.menu-item-has-children").click(function () {
        //     $(this).children('ul').slideToggle({
        //         start: function () {
        //             $(this).css({
        //                 display: "flex"
        //             })
        //         }
        //     });
        //     $(this).toggleClass('open');
        //
        //     $(this).siblings('li').children('ul').slideUp();
        //     $(this).siblings('li').removeClass('open');
        // });

    });
}(jQuery));

function initMap() {
    if($('#map').length) {
        var map = new google.maps.Map(document.getElementById('map'), {
            center: {lat: 52.193624, lng: 20.930027},
            zoom: 15,
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#444444"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#ffffff"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
        });
        var marker = new google.maps.Marker({
            position: {lat: 52.193624, lng: 20.930027},
            map: map,
            icon: '/wp-content/themes/wp-bootstrap-gulp/dist/images/placemark.png'
        });
    }
}